import HomeOutlineSix from '@assets/icons/home-outline-six.svg'
import { Icon } from './Icon'

export const HomeOutlineSixIcon = Icon(HomeOutlineSix)
